// Images - SliceLife
import ArugulaSalad from "../images/SliceLife/ArugulaSalad.jpg"
import CapresseSalad from "../images/SliceLife/CapresseSalad.jpg"
import SpinachCalzone from "../images/SliceLife/SpinachCalzone.jpg"
import CheesePizza from "../images/SliceLife/CheesePizza.jpg"
import DaHillPizza from "../images/SliceLife/DaHillPizza.jpg"
import MargaritaPizza from "../images/SliceLife/MargaritaPizza.jpg"
import PepperoniPizza from "../images/SliceLife/PepperoniPizza.jpg"

// Images - Appetizer
import GarlicKnots from "../images/Welch/Appetizer/GarlicKnots.jpg"
import MozzarellaSticks from "../images/Welch/Appetizer/MozzarellaSticks.jpg"
import FrenchFries from "../images/Welch/Appetizer/FrenchFries.jpg"
import RomaFries from "../images/Welch/Appetizer/RomaFries.jpg"
import SweetPotatoFries from "../images/Welch/Appetizer/SweetPotatoFries.jpg"
import OnionRings from "../images/Welch/Appetizer/OnionRings.jpg"
import FriedRavioli from "../images/Welch/Appetizer/FriedRavioli.jpg"
import ChickenFingers from "../images/Welch/Appetizer/ChickenFingers.jpg"
import ChickenWings from "../images/Welch/Appetizer/ChickenWings.jpg"
import SpringRolls from "../images/Welch/Appetizer/SpringRolls.jpg"
import JalapenoPoppers from "../images/Welch/Appetizer/JalapenoPoppers.jpg"
import GarlicBread from "../images/Welch/Appetizer/GarlicBread.jpg"
import MozzarellaGarlicBread from "../images/Welch/Appetizer/MozzarellaGarlicBread.jpg"
import BuffaloFries from "../images/Welch/Appetizer/BuffaloFries.jpg"

// Images - Deli Sandwich
import RomasFamous from "../images/Welch/DeliSand/RomasFamous.jpg"
import RoastBeef from "../images/Welch/DeliSand/RoastBeef.jpg"
import CapreseSub from "../images/Welch/DeliSand/CapreseSub.jpg"
import Turkey from "../images/Welch/DeliSand/Turkey.jpg"
import Ham from "../images/Welch/DeliSand/Ham.jpg"
import HoneyMustardChicken from "../images/Welch/DeliSand/HoneyMustardChicken.jpg"
import AmericanTuna from "../images/Welch/DeliSand/AmericanTuna.jpg"
import ItalianTuna from "../images/Welch/DeliSand/ItalianTuna.jpg"
import RomasSignature from "../images/Welch/DeliSand/RomasSignature.jpg"
import RomasFavorite from "../images/Welch/DeliSand/RomasFavorite.jpg"
import BLT from "../images/Welch/DeliSand/BLT.jpg"
import BBQChickenWrap from "../images/Welch/DeliSand/BBQChickenWrap.jpg"
import CaesarWrap from "../images/Welch/DeliSand/CaesarWrap.jpg"

// Images - Hot Sub
import SteakandCheese from "../images/Welch/HotSub/SteakandCheese.jpg"
import EggplantParmSub from "../images/Welch/HotSub/EggplantParmSub.jpg"
import TuscanChicken from "../images/Welch/HotSub/TuscanChicken.jpg"
import ChickenParmSub from "../images/Welch/HotSub/ChickenParmSub.jpg"
import MeatballSub from "../images/Welch/HotSub/MeatballSub.jpg"
import Pollo from "../images/Welch/HotSub/Pollo.jpg"
import VealParmSub from "../images/Welch/HotSub/VealParmSub.jpg"
import ChefsFavorite from "../images/Welch/HotSub/ChefsFavorite.jpg"

// Images - Salad
import ItalianAntipasto from "../images/Welch/Salad/ItalianAntipasto.jpg"
import Garden from "../images/Welch/Salad/Garden.jpg"
import Caesar from "../images/Welch/Salad/Caesar.jpg"
import Greek from "../images/Welch/Salad/Greek.jpg"

// Images - Salad
import PastaMeatball from "../images/Welch/Dinner/PastaMeatball.jpg"
import ChickenParm from "../images/Welch/Dinner/ChickenParm.jpg"
import EggplantParm from "../images/Welch/Dinner/EggplantParm.jpg"
import VealParm from "../images/Welch/Dinner/VealParm.jpg"
import PastaSauce from "../images/Welch/Dinner/PastaSauce.jpg"
import BakedPenne from "../images/Welch/Dinner/BakedPenne.jpg"
import ChickenFries from "../images/Welch/Dinner/ChickenFries.jpg"

// Images - Salad
import Bianca from "../images/Welch/Pizza/Bianca.jpg"
import Vegetarian from "../images/Welch/Pizza/Vegetarian.jpg"
import RomasSpecial from "../images/Welch/Pizza/RomasSpecial.jpg"
import Capri from "../images/Welch/Pizza/Capri.jpg"
import MeatLovers from "../images/Welch/Pizza/MeatLovers.jpg"
import Atwell from "../images/Welch/Pizza/Atwell.jpg"
import CapresePizza from "../images/Welch/Pizza/CapresePizza.jpg"

// Images - Placeholder
// import PH from "../images/roma-logo-half.png"

import { 
  appAdditions,
  appSauces,
  chxWingSauces,
  deliUnitList,
  deliAdditions,
  deliSpreads,
  subAdditions,
  salAdditions,
  salDressings,
  calAdditions,
  dinAdditions,
  pizAdditions,
  pizSpreads
 } from "./index"

export const diningData = {
  // Appetizers

  appetizers: [
      {
        id: "1-1",
        name: "Garlic Knots",
        quantity: null,
        unit: [
          "3 Pcs. ($2.00)"
        ],
        unitList: [
          "3 Pcs. ($2.00)"
        ],
        price: [2.00],
        note: null,
        extra: [],
        addition: appAdditions,
        spread: {},
        sauce: appSauces,
        dressing: {},
        pic: GarlicKnots
      },
      {
        id: "1-2",
        name: "Mozzarella Sticks",
        quantity: 8,
        unit: ["Pcs."],
        unitList: ["Pcs."],
        price: [8.95],
        note: null,
        extra: [],
        addition: appAdditions,
        spread: {},
        sauce: appSauces,
        dressing: {},
        pic: MozzarellaSticks
      },
      {
        id: "1-3",
        name: "French Fries",
        quantity: null,
        unit: null,
        unitList: null,
        price: [4.95],
        note: null,
        extra: [],
        addition: appAdditions,
        spread: {},
        sauce: appSauces,
        dressing: {},
        pic: FrenchFries
      },
      {
        id: "1-4",
        name: "Roma Fries",
        quantity: null,
        unit: null,
        unitList: null,
        price: [7.95],
        note: [
          "Melted Mozzarella", 
          "Crispy Bacon Bits"
        ],
        extra: [],
        addition: appAdditions,
        spread: {},
        sauce: appSauces,
        dressing: {},
        pic: RomaFries
      },
      {
        id: "1-5",
        name: "Sweet Potato Fries",
        quantity: null,
        unit: null,
        unitList: null,
        price: [5.95],
        note: null,
        extra: [],
        addition: appAdditions,
        spread: {},
        sauce: appSauces,
        dressing: {},
        pic: SweetPotatoFries
      },
      {
        id: "1-6",
        name: "Onion Rings",
        quantity: null,
        unit: null,
        unitList: null,
        price: [5.95],
        note: null,
        extra: [],
        addition: appAdditions,
        spread: {},
        sauce: appSauces,
        dressing: {},
        pic: OnionRings
      },
      {
        id: "1-7",
        name: "Fried Ravioli",
        quantity: 7,
        unit: ["Pcs."],
        unitList: ["Pcs."],
        price: [7.95],
        note: null,
        extra: [],
        addition: appAdditions,
        spread: {},
        sauce: appSauces,
        dressing: {},
        pic: FriedRavioli
      },
      {
        id: "1-8",
        name: "Chicken Fingers",
        quantity: 6,
        unit: ["Pcs."],
        unitList: ["Pcs."],
        price: [9.95],
        note: null,
        extra: [],
        addition: appAdditions,
        spread: {},
        sauce: appSauces,
        dressing: {},
        pic: ChickenFingers
      },
      {
        id: "1-9",
        name: "Chicken Wings",
        quantity: 8,
        unit: ["Wings"],
        unitList: ["Pcs."],
        price: [9.95],
        note: null,
        extra: [],
        addition: appAdditions,
        spread: chxWingSauces,
        sauce: {},
        dressing: {},
        pic: ChickenWings
      },
      {
        id: "1-10",
        name: "Fried Vegetable Spring Rolls",
        quantity: 6,
        unit: ["Pcs."],
        unitList: ["Pcs."],
        price: [7.95], 
        note: null,
        extra: [],
        addition: appAdditions,
        spread: {},
        sauce: appSauces,
        dressing: {},
        pic: SpringRolls
      },
      {
        id: "1-11",
        name: "Jalapeno Poppers",
        quantity: 8,
        unit: ["Pcs."],
        unitList: ["Pcs."],
        price: [5.95],
        note: null,
        extra: [],
        addition: appAdditions,
        spread: {},
        sauce: appSauces,
        dressing: {},
        pic: JalapenoPoppers
      },
      // {
      //   id: "1-12",
      //   name: "Fried Pickle Chips",
      //   quantity: null,
      //   unit: null,
      //   unitList: null,
      //   price: [5.95],
      //   note: null,
      //   extra: [],
      //   addition: appAdditions,
      //   spread: {},
      //   sauce: appSauces,
      //   dressing: {},
      //   pic: PH
      // },
      {
        id: "1-13",
        name: "Garlic Bread",
        quantity: 2,
        unit: ["Half Pcs."],
        unitList: ["Half Pcs."],
        price: [2.95],
        note: null,
        extra: [],
        addition: appAdditions,
        spread: {},
        sauce: appSauces,
        dressing: {},
        pic: GarlicBread
      },
      {
        id: "1-14",
        name: "Mozzarella Garlic Bread",
        quantity: 2,
        unit: ["Half Pcs."],
        unitList: ["Half Pcs."],
        price: [3.95],
        note: ["Melted Mozzarella"],
        extra: [],
        addition: appAdditions,
        spread: {},
        sauce: appSauces,
        dressing: {},
        pic: MozzarellaGarlicBread
      },
      // {
      //   id: "1-15",
      //   name: "Potato Chips",
      //   quantity: null,
      //   unit: null,
      //   unitList: null,
      //   price: [1.25],
      //   note: null,
      //   extra: [],
      //   addition: {},
      //   spread: {},
      //   sauce: {},
      //   dressing: {},
      //   pic: PH
      // },      
      {
        id: "1-16",
        name: "Buffalo Fries",
        quantity: null,
        unit: null,
        unitList: null,
        price: [6.95],
        note: [
          "Crumbled Bacon", 
          "Ranch Drizzle", 
          "Bleu Cheese"],
        extra: [],
        addition: appAdditions,
        spread: {},
        sauce: appSauces,
        dressing: {},
        pic: BuffaloFries
      }
    ],

  // Deli Sandwiches

  deliSandwiches: [
    {
      id: "2-1",
      name: "Roma's Famous Original Italian Grinder",
      quantity: null,
      unit: [
        "Wrap",
        "Panini"
      ],
      unitList: deliUnitList,
      price: [11.99],
      note: [
        "Capicola",
        "Salami",
        "Ham",
        "Mortadella",
        "Sharp Provolone",
        "Lettuce",
        "Tomatoes",
        "Hot Pepper Rings",
        "Red Onion",
        "Sliced Olives",
        "Special House Dressing"
      ],
      extra: [
        "Sliced Pickles",
        "Bell Pepper",
      ],
      addition: deliAdditions,
      spread: deliSpreads,
      sauce: {},
      dressing: {},
      pic: RomasFamous
    },
    {
      id: "2-2",
      name: "Roast Beef",
      quantity: null,
      unit: [
        "Wrap",
        "Panini"
      ],
      unitList: deliUnitList,
      price: [12.99],
      note: [
        "Oven Roasted Beef",
        "Cheddar",
        "Lettuce",
        "Tomatoes",
        "Red Onion"
      ],
      extra: [
        "Sliced Pickles",
        "Bell Pepper",
        "Sliced Olives",
        "Hot Pepper Rings",
      ],
      addition: deliAdditions,
      spread: deliSpreads,
      sauce: {},
      dressing: {},
      pic: RoastBeef
    },
    {
      id: "2-3",
      name: "Caprese",
      quantity: null,
      unit: [
        "Wrap",
        "Panini"
      ],
      unitList: deliUnitList,
      price: [9.99],
      note: [
        "Mozzarella",
        "Tomatoes",
        "Basil",
        "Balsamic Glaze",
        "Cracked Black Pepper",
        "Extra Virgin Olive Oil"
      ],
      extra: [
        "Lettuce",
        "Red Onion",
        "Sliced Pickles",
        "Bell Pepper",
        "Sliced Olives",
        "Hot Pepper Rings",
      ],
      addition: deliAdditions,
      spread: deliSpreads,
      sauce: {},
      dressing: {},
      pic: CapreseSub
    },
    {
      id: "2-4",
      name: "Turkey",
      quantity: null,
      unit: [
        "Wrap",
        "Panini"
      ],
      unitList: deliUnitList,
      price: [12.99],
      note: [
        "Sliced Turkey Breast",
        "Lettuce",
        "Tomatoes",
        "American Cheese",
      ],
      extra: [
        "Red Onion",
        "Sliced Pickles",
        "Bell Pepper",
        "Sliced Olives",
        "Hot Pepper Rings",
      ],
      addition: deliAdditions,
      spread: deliSpreads,
      sauce: {},
      dressing: {},
      pic: Turkey
    },
    {
      id: "2-5",
      name: "Ham",
      quantity: null,
      unit: [
        "Wrap",
        "Panini"
      ],
      unitList: deliUnitList,
      price: [9.49],
      note: [
        "Sliced Ham",
        "Swiss Cheese",
        "Lettuce",
        "Tomatoes"
      ],
      extra: [
        "Red Onion",
        "Sliced Pickles",
        "Bell Pepper",
        "Sliced Olives",
        "Hot Pepper Rings",
      ],
      addition: deliAdditions,
      spread: deliSpreads,
      sauce: {},
      dressing: {},
      pic: Ham
    },
    {
      id: "2-6",
      name: "Honey Mustard Chicken",
      quantity: null,
      unit: [
        "Wrap",
        "Panini"
      ],
      unitList: deliUnitList,
      price: [11.95],
      note: [
        "Marinated Grilled Chicken",
        "Bacon",
        "Swiss",
        "Lettuce",
        "Tomatoes"
      ],
      extra: [
        "Red Onion",
        "Sliced Pickles",
        "Bell Pepper",
        "Sliced Olives",
        "Hot Pepper Rings",
      ],
      addition: deliAdditions,
      spread: deliSpreads,
      sauce: {},
      dressing: {},
      pic: HoneyMustardChicken
    },
    {
      id: "2-7",
      name: "American Tuna",
      quantity: null,
      unit: [
        "Wrap",
        "Panini"
      ],
      unitList: deliUnitList,
      price: [10.99],
      note: [
        "Albacore Tuna Salad",
        "Lettuce",
        "Tomatoes",
        "Red Onion"
      ],
      extra: [
        "Sliced Pickles",
        "Bell Pepper",
        "Sliced Olives",
        "Hot Pepper Rings",
      ],
      addition: deliAdditions,
      spread: deliSpreads,
      sauce: {},
      dressing: {},
      pic: AmericanTuna
    },
    {
      id: "2-8",
      name: "Italian Tuna",
      quantity: null,
      unit: [
        "Wrap",
        "Panini"
      ],
      unitList: deliUnitList,
      price: [11.99],
      note: [
        "Albacore Tuna Salad",
        "Lettuce",
        "Tomatoes",
        "Red Onion"
      ],
      extra: [
        "Sliced Pickles",
        "Bell Pepper",
        "Sliced Olives",
        "Hot Pepper Rings",
      ],
      addition: deliAdditions,
      spread: deliSpreads,
      sauce: {},
      dressing: {},
      pic: ItalianTuna
    },
    {
      id: "2-9",
      name: "Roma's Signature",
      quantity: null,
      unit: [
        "Wrap",
        "Panini"
      ],
      unitList: deliUnitList,
      price: [13.99],
      note: [
        "Italian Ham",
        "Mozzarella",
        "Tomatoes",
        "Basil",
        "Cracked Black Pepper",
        "Extra Virgin Olive Oil"
      ],
      extra: [
        "Lettuce",
        "Red Onion",
        "Sliced Pickles",
        "Bell Pepper",
        "Sliced Olives",
        "Hot Pepper Rings",
      ],
      addition: deliAdditions,
      spread: deliSpreads,
      sauce: {},
      dressing: {},
      pic: RomasSignature
    },
    {
      id: "2-10",
      name: "Roma's Favorite",
      quantity: null,
      unit: [
        "Wrap",
        "Panini"
      ],
      unitList: deliUnitList,
      price: [11.95],
      note: [
        "Sopresatta",
        "Baby Arugula",
        "Sharp Provolone",
        "Roasted Peppers",
        "Cracked Black Pepper",
        "Extra Virgin Olive Oil"
      ],
      extra: [
        "Lettuce",
        "Tomatoes",
        "Red Onion",
        "Sliced Pickles",
        "Bell Pepper",
        "Sliced Olives",
        "Hot Pepper Rings"
      ],
      addition: deliAdditions,
      spread: deliSpreads,
      sauce: {},
      dressing: {},
      pic: RomasFavorite
    },
    {
      id: "2-11",
      name: "BLT",
      quantity: null,
      unit: [
        "Wrap",
        "Panini"
      ],
      unitList: deliUnitList,
      price: [7.95],
      note: [
        "Bacon",
        "Lettuce",
        "Tomatoes"
      ],
      extra: [
        "Red Onion",
        "Sliced Pickles",
        "Bell Pepper",
        "Sliced Olives",
        "Hot Pepper Rings",
      ],
      addition: deliAdditions,
      spread: deliSpreads,
      sauce: {},
      dressing: {},
      pic: BLT
    },
    {
      id: "2-12",
      name: "Caesar Chicken Wrap",
      quantity: null,
      unit: ["Wrap"],
      unitList: [
        "Wheat Wrap",
        "White Wrap"
      ],
      price: [11.99],
      note: [
        "Grilled Chicken",
        "Romaine Lettuce",
        "Caesar Dressing",
        "Shaved Parmigiano"
      ],
      extra: [
        "Tomatoes",
        "Red Onion",
        "Sliced Pickles",
        "Bell Pepper",
        "Sliced Olives",
        "Hot Pepper Rings",
      ],
      addition: deliAdditions,
      spread: deliSpreads,
      sauce: {},
      dressing: {},
      pic: CaesarWrap
    },
    {
      id: "2-13",
      name: "BBQ Chicken Wrap",
      quantity: null,
      unit: ["Wrap"],
      unitList: [
        "Wheat Wrap",
        "White Wrap"
      ],
      price: [10.99],
      note: [
        "Pulled Chicken",
        "Romaine Lettuce",
        "Tomatoes",
        "BBQ Sauce",
      ],
      extra: [
        "Red Onion",
        "Sliced Pickles",
        "Bell Pepper",
        "Sliced Olives",
        "Hot Pepper Rings",
      ],
      addition: deliAdditions,
      spread: deliSpreads,
      sauce: {},
      dressing: {},
      pic: BBQChickenWrap
    }
  ],

  // Hot Subs

  hotSubs: [
    {
      id: "3-1",
      name: "Steak and Cheese",
      quantity: null,
      unit: ["Soft Torpedo Roll", "Hard Torpedo Roll"],
      unitList: ["Soft Torpedo Roll", "Hard Torpedo Roll"],
      price: [8.99],
      note: [
        "Shaved Steak",
        "American Cheese"
      ],
      extra: [],
      addition: subAdditions,
      spread: {},
      sauce: {},
      dressing: {},
      pic: SteakandCheese
    },
    {
      id: "3-2",
      name: "Eggplant Parmigiano",
      quantity: null,
      unit: ["Soft Torpedo Roll", "Hard Torpedo Roll"],
      unitList: ["Soft Torpedo Roll", "Hard Torpedo Roll"],
      price: [11.99],
      note: [
        "Fried Eggplant",
        "Tomato Sauce",
        "Mozzarella Cheese"
      ],
      extra: [],
      addition: subAdditions,
      spread: {},
      sauce: {},
      dressing: {},
      pic: EggplantParmSub
    },
    {
      id: "3-3",
      name: "Tuscano Chicken",
      quantity: null,
      unit: ["Soft Torpedo Roll", "Hard Torpedo Roll"],
      unitList: ["Soft Torpedo Roll", "Hard Torpedo Roll"],
      price: [12.99],
      note: [
        "Marinated Grilled Chicken",
        "Tomatoes",
        "Lettuce",
        "Sliced Provolone",
        "Basil Pesto",
      ],
      extra: [],
      addition: subAdditions,
      spread: {},
      sauce: {},
      dressing: {},
      pic: TuscanChicken
    },
    {
      id: "3-4",
      name: "Chicken Parmigiano",
      quantity: null,
      unit: ["Soft Torpedo Roll", "Hard Torpedo Roll"],
      unitList: ["Soft Torpedo Roll", "Hard Torpedo Roll"],
      price: [12.99],
      note: [
        "Fried Chicken Breast",
        "Mozzarella Cheese",
        "Tomato Sauce",
      ],
      extra: [],
      addition: subAdditions,
      spread: {},
      sauce: {},
      dressing: {},
      pic: ChickenParmSub
    },
    {
      id: "3-5",
      name: "Meatball",
      quantity: null,
      unit: ["Soft Torpedo Roll", "Hard Torpedo Roll"],
      unitList: ["Soft Torpedo Roll", "Hard Torpedo Roll"],
      price: [11.99],
      note: [
        "Meatballs",
        "Tomato Sauce"
      ],
      extra: [],
      addition: subAdditions,
      spread: {},
      sauce: {},
      dressing: {},
      pic: MeatballSub
    },
    {
      id: "3-6",
      name: "Pollo",
      quantity: null,
      unit: ["Soft Torpedo Roll", "Hard Torpedo Roll"],
      unitList: ["Soft Torpedo Roll", "Hard Torpedo Roll"],
      price: [12.99],
      note: [
        "Chicken Cutlet",
        "Lettuce",
        "Tomatoes",
        "Sliced Provolone",
        "Mayonnaise"
      ],
      extra: [],
      addition: subAdditions,
      spread: {},
      sauce: {},
      dressing: {},
      pic: Pollo
    },
    {
      id: "3-7",
      name: "Veal Parmigiano",
      quantity: null,
      unit: ["Soft Torpedo Roll", "Hard Torpedo Roll"],
      unitList: ["Soft Torpedo Roll", "Hard Torpedo Roll"],
      price: [12.95],
      note: [
        "Fried Veal Scallopine",
        "Mozzarella Cheese",
        "Tomato Sauce",
      ],
      extra: [],
      addition: subAdditions,
      spread: {},
      sauce: {},
      dressing: {},
      pic: VealParmSub
    },
    {
      id: "3-8",
      name: "Chef's Favorite",
      quantity: null,
      unit: ["Soft Torpedo Roll", "Hard Torpedo Roll"],
      unitList: ["Soft Torpedo Roll", "Hard Torpedo Roll"],
      price: [13.99],
      note: [
        "Shaved Steak",
        "Peppers",
        "Hot Pepper Rings",
        "Mushrooms",
        "Sauteed Onions",
        "Sharp Provolone",
      ],
      extra: [],
      addition: subAdditions,
      spread: {},
      sauce: {},
      dressing: {},
      pic: ChefsFavorite
    }
  ],

  // Specialty Salad

  specialtySalads: [
    {
      id: "4-1",
      name: "Italian Antipasto",
      quantity: null,
      unit: ["Salad"],
      unitList: ["Salad"],
      price: [13.95],
      note: [
        "Mixed Field Greens",
        "Tomatoes",
        "Cucumbers",
        "Sliced Olives",
        "Pepper Rings",
        "Roasted Peppers",
        "Marinated Mushrooms",
        "Salami",
        "Ham",
        "Capicollo",
        "Sopresatta",
        "Sharp Provolone",
        "Mortadella",
      ],
      extra: [],
      addition: salAdditions,
      spread: {},
      sauce: {},
      dressing: salDressings,
      pic: ItalianAntipasto
    },
    {
      id: "4-2",
      name: "Garden",
      quantity: null,
      unit: ["Salad"],
      unitList: ["Salad"],
      price: [6.95],
      note: [
        "Mixed Field Greens",
        "Tomatoes",
        "Cucumbers",
        "Sliced Olives",
        "Pepper Rings",
        "Red Onions",
        "Shaved Parmigiano",
        "Homestyle Croutons",
      ],
      extra: [],
      addition: salAdditions,
      spread: {},
      sauce: {},
      dressing: salDressings,
      pic: Garden
    },
    {
      id: "4-3",
      name: "Caesar",
      quantity: null,
      unit: ["Salad"],
      unitList: ["Salad"],
      price: [8.95],
      note: [
        "Romaine Lettuce",
        "Shredded Parmigiano",
        "Homestyle Croutons",
      ],
      extra: [],
      addition: salAdditions,
      spread: {},
      sauce: {},
      dressing: salDressings,
      pic: Caesar
    },
    {
      id: "4-4",
      name: "Caprese",
      quantity: null,
      unit: ["Salad"],
      unitList: ["Salad"],
      price: [10.95],
      note: [
        "Baby Greens",
        "Tomatoes",
        "Roasted Peppers",
        "Basil",
        "Mozzarella",
        "Cracked Black Pepper",
        "Balsamic Glaze",
        "Extra Virgin Olive Oil",
      ],
      extra: [],
      addition: salAdditions,
      spread: {},
      sauce: {},
      dressing: salDressings,
      pic: CapresseSalad
    },
    {
      id: "4-5",
      name: "Arugula",
      quantity: null,
      unit: ["Salad"],
      unitList: ["Salad"],
      price: [10.95],
      note: [
        "Baby Arugula",
        "Cucumbers",
        "Tomatoes",
        "Caramelized Onions",
        "Crumbled Goat Cheese",
        "Homestyle Croutons"
      ],
      extra: [],
      addition: salAdditions,
      spread: {},
      sauce: {},
      dressing: salDressings,
      pic: ArugulaSalad
    },
    {
      id: "4-6",
      name: "Greek",
      quantity: null,
      unit: ["Salad"],
      unitList: ["Salad"],
      price: [10.95],
      note: [
        "Mixed Field Greens",
        "Romaine Lettuce",
        "Cucumbers",
        "Tomatoes",
        "Red Onions",
        "Sliced Olives",
        "Pepperoncini",
        "Feta Cheese",
        "Cracked Black Pepper",
      ],
      extra: [],
      addition: salAdditions,
      spread: {},
      sauce: {},
      dressing: salDressings,
      pic: Greek
    }
  ],

  // Calzones

  calzones: [
    {
      id: "5-1",
      name: "Pepperoni",
      quantity: null,
      unit: ["Calzone"],
      unitList: ["Calzone"],
      price: [10.95],
      note: [
        "Pepperoni"
      ],
      extra: [],
      addition: calAdditions,
      spread: {},
      sauce: {},
      dressing: {},
      pic: SpinachCalzone
    },
    {
      id: "5-2",
      name: "Sausage",
      quantity: null,
      unit: ["Calzone"],
      unitList: ["Calzone"],
      price: [8.95],
      note: [
        "Sausage"
      ],
      extra: [],
      addition: calAdditions,
      spread: {},
      sauce: {},
      dressing: {},
      pic: SpinachCalzone
    },
    {
      id: "5-3",
      name: "Sausage, Pepperoni, and Caramelized Onions",
      quantity: null,
      unit: ["Calzone"],
      unitList: ["Calzone"],
      price: [12.95],
      note: [
        "Sausage",
        "Pepperoni",
        "Caramelized Onions"
      ],
      extra: [],
      addition: calAdditions,
      spread: {},
      sauce: {},
      dressing: {},
      pic: SpinachCalzone
    },
    {
      id: "5-4",
      name: "Chicken Parmigiana",
      quantity: null,
      unit: ["Calzone"],
      unitList: ["Calzone"],
      price: [11.95],
      note: [
        "Chicken",
        "Parmesan Cheese"
      ],
      extra: [],
      addition: calAdditions,
      spread: {},
      sauce: {},
      dressing: {},
      pic: SpinachCalzone
    },
    {
      id: "5-5",
      name: "Spinach, Pepperoni, and Olive",
      quantity: null,
      unit: ["Calzone"],
      unitList: ["Calzone"],
      price: [11.95],
      note: [
        "Spinach",
        "Pepperoni",
        "Olive"
      ],
      extra: [],
      addition: calAdditions,
      spread: {},
      sauce: {},
      dressing: {},
      pic: SpinachCalzone
    },
    {
      id: "5-6",
      name: "Shaved Steak, Peppers, Onions, and Mushrooms",
      quantity: null,
      unit: ["Calzone"],
      unitList: ["Calzone"],
      price: [13.95],
      note: [
        "Shaved Steak",
        "Peppers",
        "Onions",
        "Mushrooms"
      ],
      extra: [],
      addition: calAdditions,
      spread: {},
      sauce: {},
      dressing: {},
      pic: SpinachCalzone
    },
    {
      id: "5-7",
      name: "Eggplant Parmigiana",
      quantity: null,
      unit: ["Calzone"],
      unitList: ["Calzone"],
      price: [11.95],
      note: [
        "Eggplant",
        "Parmesan Cheese"
      ],
      extra: [],
      addition: calAdditions,
      spread: {},
      sauce: {},
      dressing: {},
      pic: SpinachCalzone
    },
    {
      id: "5-8",
      name: "Breaded Chicken and Bacon",
      quantity: null,
      unit: ["Calzone"],
      unitList: ["Calzone"],
      price: [11.95],
      note: [
        "Breaded Chicken",
        "Bacon",
        "American Cheese",
      ],
      extra: [],
      addition: calAdditions,
      spread: {},
      sauce: {},
      dressing: {},
      pic: SpinachCalzone
    },
    {
      id: "5-9",
      name: "Buffalo Breaded Chicken",
      quantity: null,
      unit: ["Calzone"],
      unitList: ["Calzone"],
      price: [11.95],
      note: [
        "Buffalo Breaded Chicken",
        "American Cheese",
        "Blue Cheese",
      ],
      extra: [],
      addition: calAdditions,
      spread: {},
      sauce: {},
      dressing: {},
      pic: SpinachCalzone
    },
    {
      id: "5-10",
      name: "Spinach",
      quantity: null,
      unit: ["Calzone"],
      unitList: ["Calzone"],
      price: [10.95],
      note: [
        "Spinach"
      ],
      extra: [],
      addition: calAdditions,
      spread: {},
      sauce: {},
      dressing: {},
      pic: SpinachCalzone
    },
    {
      id: "5-11",
      name: "Meatball Parmigiana",
      quantity: null,
      unit: ["Calzone"],
      unitList: ["Calzone"],
      price: [11.95],
      note: [
        "Meatball",
        "Parmesan Cheese"
      ],
      extra: [],
      addition: calAdditions,
      spread: {},
      sauce: {},
      dressing: {},
      pic: SpinachCalzone
    }
  ],

  // Dinners

  dinners: [
    {
      id: "6-1",
      name: "Meatballs (2) (w/penne)",
      quantity: null,
      unit: null,
      unitList: null,
      price: [13.95],
      note: [
        "Tomato Sauce"
      ],
      extra: [],
      addition: dinAdditions,
      spread: {},
      sauce: {},
      dressing: {},
      pic: PastaMeatball
    },
    {
      id: "6-2",
      name: "Chicken Parmigiana (w/penne)",
      quantity: null,
      unit: null,
      unitList: null,
      price: [15.95],
      note: [
        "Tomato Sauce",
        "Chicken",
        "Parmesan Cheese"
      ],
      extra: [],
      addition: dinAdditions,
      spread: {},
      sauce: {},
      dressing: {},
      pic: ChickenParm
    },
    {
      id: "6-3",
      name: "Eggplant Parmigiana (w/penne)",
      quantity: null,
      unit: null,
      unitList: null,
      price: [13.95],
      note: [
        "Tomato Sauce",
        "Eggplant",
        "Parmesan Cheese"
      ],
      extra: [],
      addition: dinAdditions,
      spread: {},
      sauce: {},
      dressing: {},
      pic: EggplantParm
    },
    {
      id: "6-4",
      name: "Veal Parmigiana (w/penne)",
      quantity: null,
      unit: null,
      unitList: null,
      price: [17.95],
      note: [
        "Tomato Sauce",
        "Veal",
        "Parmesan Cheese"
      ],
      extra: [],
      addition: dinAdditions,
      spread: {},
      sauce: {},
      dressing: {},
      pic: VealParm
    },
    {
      id: "6-5",
      name: "Tomato Sauce Only (w/penne)",
      quantity: null,
      unit: null,
      unitList: null,
      price: [9.95],
      note: [
        "Tomato Sauce"
      ],
      extra: [],
      addition: dinAdditions,
      spread: {},
      sauce: {},
      dressing: {},
      pic: PastaSauce
    },
    {
      id: "6-6",
      name: "Baked Penne with Mozzarella, Ricotta, and Parmigiano",
      quantity: null,
      unit: null,
      unitList: null,
      price: [12.95],
      note: [
        "Mozzarella Cheese",
        "Riccota Cheese",
        "Parmesan Cheese"
      ],
      extra: [],
      addition: dinAdditions,
      spread: {},
      sauce: {},
      dressing: {},
      pic: BakedPenne
    },
    {
      id: "6-7",
      name: "Chicken Fingers and Fries",
      quantity: null,
      unit: null,
      unitList: null,
      price: [8.95],
      note: null,
      extra: [],
      addition: dinAdditions,
      spread: {},
      sauce: appSauces,
      dressing: {},
      pic: ChickenFries
    }
  ],

  // Brick Oven Pizza

  pizzas: [
    {
      id: "7-1",
      name: "Build Your Own Brick Oven Pizza",
      quantity: null,
      size: [
        '12" Indiv.',
        '18" Large',
        '12" Indiv. - Gluten Free',
        '18" Large - Gluten Free'
      ],
      unit: [
        "Cheese",
        "1 Topping",
        "2 Topping",
        "3 Topping",
        "4 Topping"
      ],
      unitList: [
        "Cheese",
        "1 Topping",
        "2 Topping",
        "3 Topping",
        "4 Topping"
      ],
      price: [
        "11.95",
        "15.95"
      ],
      note: ['Additional toppings (12" $1.00)/(18" $2.00)'],
      extra: [
        "Pepperoni",
        "Crumbled Sausage",
        "Bacon",
        "Ham",
        "Meatball",
        "Grilled Chicken",
        "Chicken Cutlet",
        "Capicollo",
        "Prosciutto",
        "Anchovie",

        "Eggplant",
        "Sliced Tomato",
        "Mushroom",
        "Pineapple",
        "Pepper",
        "Hot Pepper Rings",
        "Roasted Pepper",
        "Onion",
        "Caramelized Onion",
        "Spinach",
        "Broccoli",
        "Olive",
        "Artichoke",
        "Fresh Basil",    
        "Fresh Garlic",        
      ],      
      addition: pizAdditions,
      spread: pizSpreads,
      sauce: {},
      dressing: {},
      pic: CheesePizza
    },
    {
      id: "7-2",
      name: "Margherita",
      quantity: null,
      size: [
        '12" Indiv.',
        '18" Large',
        '12" Indiv. - Gluten Free',
        '18" Large - Gluten Free'
      ],
      unit: ["Pizza"],
      unitList: ["Cheese"],
      price: [
        13.95,
        18.95
      ],
      note: [
        "Basil",
        "Shredded Mozzarella",
        "Extra Virgin Olive Oil",
      ],
      extra: null,
      addition: pizAdditions,
      spread: pizSpreads,
      sauce: {},
      dressing: {},
      pic: MargaritaPizza
    },
    {
      id: "7-3",
      name: "Bianca (no sauce)",
      quantity: null,
      size: [
        '12" Indiv.',
        '18" Large',
        '12" Indiv. - Gluten Free',
        '18" Large - Gluten Free'
      ],
      unit: ["Pizza"],
      unitList: ["Cheese"],
      price: [
        14.95,
        19.95
      ],
      note: [
        "Garlic",
        "Oregano",
        "Mozzarella",
        "Ricotta",
        "Grated Parmigiano",
        "Extra Virgin Olive Oil",
      ],
      extra: null,
      addition: pizAdditions,
      spread: null,
      sauce: {},
      dressing: {},
      pic: Bianca
    },
    {
      id: "7-4",
      name: "Pepperoni",
      quantity: null,
      size: [
        '12" Indiv.',
        '18" Large',
        '12" Indiv. - Gluten Free',
        '18" Large - Gluten Free'
      ],
      unit: ["Pizza"],
      unitList: ["Cheese"],
      price: [
        13.95,
        18.95
      ],
      note: [
        "Pepperoni",
        "Shredded Mozzarella",
      ],
      extra: null,
      addition: pizAdditions,
      spread: pizSpreads,
      sauce: {},
      dressing: {},
      pic: PepperoniPizza
    },
    {
      id: "7-5",
      name: "Vegetarian",
      quantity: null,
      size: [
        '12" Indiv.',
        '18" Large',
        '12" Indiv. - Gluten Free',
        '18" Large - Gluten Free'
      ],
      unit: ["Pizza"],
      unitList: ["Cheese"],
      price: [
        16.95,
        21.95
      ],
      note: [
        "Caramelized Onions",
        "Bell Peppers",
        "Mushrooms",
        "Sauteed Spinach",
        "Sliced Olives",
        "Artichoke",
        "Shredded Mozzarella",
        "Pesto Genoese",
      ],
      extra: null,
      addition: pizAdditions,
      spread: pizSpreads,
      sauce: {},
      dressing: {},
      pic: Vegetarian
    },
    {
      id: "7-6",
      name: "Roma's Special",
      quantity: null,
      size: [
        '12" Indiv.',
        '18" Large',
        '12" Indiv. - Gluten Free',
        '18" Large - Gluten Free'
      ],
      unit: ["Pizza"],
      unitList: ["Cheese"],
      price: [
        16.95,
        22.95
      ],
      note: [
        "Bacon",
        "Pepperoni",
        "Mushrooms",
        "Onions",
        "Bell Peppers",
        "Sliced Olives",
        "Hot Pepper Rings",
        "Shredded Mozzarella",
      ],
      extra: null,
      addition: pizAdditions,
      spread: pizSpreads,
      sauce: {},
      dressing: {},
      pic: RomasSpecial
    },
    {
      id: "7-7",
      name: "Capri",
      quantity: null,
      size: [
        '12" Indiv.',
        '18" Large',
        '12" Indiv. - Gluten Free',
        '18" Large - Gluten Free'
      ],
      unit: ["Pizza"],
      unitList: ["Cheese"],
      price: [
        15.95,
        20.95
      ],
      note: [
        "Roasted Peppers",
        "Spinach",
        "Shredded Mozzarella",
        "Ricotta",
      ],
      extra: null,
      addition: pizAdditions,
      spread: pizSpreads,
      sauce: {},
      dressing: {},
      pic: Capri
    },
    {
      id: "7-8",
      name: "Meat Lover's",
      quantity: null,
      size: [
        '12" Indiv.',
        '18" Large',
        '12" Indiv. - Gluten Free',
        '18" Large - Gluten Free'
      ],
      unit: ["Pizza"],
      unitList: ["Cheese"],
      price: [
        16.95,
        22.95
      ],
      note: [
        "Crumbled Meatball",
        "Crumbled Bacon",
        "Pepperoni",
        "Sausage",
        "Ham",
        "Capocollo",
        "Mozzarella",
      ],
      extra: null,
      addition: pizAdditions,
      spread: pizSpreads,
      sauce: {},
      dressing: {},
      pic: MeatLovers
    },
    {
      id: "7-9",
      name: "Da Hill",
      quantity: null,
      size: [
        '12" Indiv.',
        '18" Large',
        '12" Indiv. - Gluten Free',
        '18" Large - Gluten Free'
      ],
      unit: ["Pizza"],
      unitList: ["Cheese"],
      price: [
        14.95,
        21.95
      ],
      note: [
        "Crumbled Sausage",
        "Caramelized Onions",
        "Sauteed Broccoli Rabe",
        "Shredded Mozzarella",
      ],
      extra: null,
      addition: pizAdditions,
      spread: pizSpreads,
      sauce: {},
      dressing: {},
      pic: DaHillPizza
    },
    {
      id: "7-10",
      name: "Atwells",
      quantity: null,
      size: [
        '12" Indiv.',
        '18" Large',
        '12" Indiv. - Gluten Free',
        '18" Large - Gluten Free'
      ],
      unit: ["Pizza"],
      unitList: ["Cheese"],
      price: [
        16.95,
        21.95
      ],
      note: [
        "Prusciutto",
        "Tomatoes",
        "Basil",
        "Shredded Mozzarella",
      ],
      extra: null,
      addition: pizAdditions,
      spread: pizSpreads,
      sauce: {},
      dressing: {},
      pic: Atwell
    },
    {
      id: "7-11",
      name: "Caprese",
      quantity: null,
      size: [
        '12" Indiv.',
        '18" Large',
        '12" Indiv. - Gluten Free',
        '18" Large - Gluten Free'
      ],
      unit: ["Pizza"],
      unitList: ["Cheese"],
      price: [
        14.95,
        18.95
      ],
      note: [
        "Tomatoes",
        "Basil",
        "Mozzarella",
        "Pesto",
        "Cracked Black Pepper",
        "Extra Virgin Olive Oil",
      ],
      extra: null,
      addition: pizAdditions,
      spread: pizSpreads,
      sauce: {},
      dressing: {},
      pic: CapresePizza
    }
  ]
};

// ($3.49/slice +$1 per extra topping) 
